export class ProposalNav {
    constructor(navSelector, itemSelector) {
        this.items = document.querySelectorAll(itemSelector);
        this.offset = 100;

        this.sectionsMap = {};
        this.items.forEach((item) => {
            const targetId = item.dataset.href;
            const section = document.getElementById(targetId);

            if (section) {
                this.sectionsMap[section.id] = item;
            }

            // eslint-disable-next-line id-blacklist
            item.addEventListener('click', (e) => {
                // eslint-disable-next-line id-blacklist
                e.preventDefault();
                const top = section.getBoundingClientRect().top + window.scrollY - this.offset;

                window.scrollTo({
                    top,
                    behavior: 'smooth'
                });

                this.items.forEach((i) => {
                    return i.classList.remove('active');
                });
                item.classList.add('active');
            });
        });

        const options = {
            root      : null,
            rootMargin: '0px 0px 0px 0px',
            threshold : 0.5
        };

        this.observer = new IntersectionObserver(this.handleIntersect.bind(this), options);

        Object.keys(this.sectionsMap).forEach((id) => {
            this.observer.observe(document.getElementById(id));
        });
    }

    handleIntersect(entries) {
        const visibleSections = entries.filter((entry) => {
            return entry.isIntersecting;
        });

        if (visibleSections.length === 0) {
            this.items.forEach((i) => {
                return i.classList.remove('active');
            });

            return;
        }

        const topSection = visibleSections.reduce((prev, curr) => {
            return prev.boundingClientRect.top < curr.boundingClientRect.top ? prev : curr;
        });

        const item = this.sectionsMap[topSection.target.id];

        this.items.forEach((i) => {
            return i.classList.remove('active');
        });
        if (item) {
            item.classList.add('active');
        }
    }
}
